import React from 'react'
import Autosuggest from 'react-autosuggest';
import { searchService } from '_services';
import styles from './DiagnosisSearch.module.css';

export class DiagnosisSearch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            suggestions: [],
            loading: false
        };
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    }

    diags = [];

    async getDiags(value) {
        var retval = [];
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        if (inputLength >= 3) {
            var tmp = await searchService.diagSearch(this.props.epno, inputValue, this.props.trtDiagSearch);
            retval = tmp.entities.results ? Object.values(tmp.entities.results) : [];
        }
        return retval;
    }

    getSuggestionValue(suggestion) {
        return suggestion.d1Code + ' - ' + suggestion.d1Desc;
    }

    renderSuggestion(suggestion) {
        return (
            <span title={suggestion.d1Code + ' - ' + suggestion.d1Desc}>{suggestion.d1Code + ' - ' + suggestion.d1Desc}</span>
        );
    }


    async loadSuggestions(value) {

        this.setState({
            isLoading: true
        });

        this.diags = await this.getDiags(value);
        this.setState({
            isLoading: false,
            suggestions: this.diags
        });
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    onBlur = (event, { highlightedSuggestion }) => {
        if (this.diags && this.diags.filter(diag => diag.d1Code + ' - ' + diag.d1Desc === this.state.value).length !== 1) {
            this.setState({
                value: ''
            });
        }
    }

    onSuggestionSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
        if (this.props.onAddDiag) {
            // let val = this.state.value ? this.state.value.substring(0, this.state.value.indexOf('-')).trim() : '';
            this.props.onAddDiag(suggestion.d1Code);
        }
        this.setState({ value: '' });
        if (this.props.onSelected) {
            this.props.onSelected(suggestion.d1Code);
        }
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };


    addDiag() {
        if (this.props.onAddDiag) {
            let val = this.state.value ? this.state.value.substring(0, this.state.value.indexOf('-')).trim() : '';
            this.props.onAddDiag(val);
        }
        this.setState({ value: '' });
    }


    render() {

        const justify = this.props.justify ? this.props.justify : 'left';
        const suggestionsWidth = this.props.suggestionsWidth ? this.props.suggestionsWidth : '700px';
        const theme = {
            container: {
                position: 'relative'
            },
            input: {
                width: '100%',
                padding: '10px 10px',
            },
            inputFocused: {
                outline: 'none'
            },
            inputOpen: {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            },
            suggestionsContainer: {
                display: 'none'
            },
            suggestionsContainerOpen: {
                display: 'block',
                position: 'absolute',
                width: suggestionsWidth,
                border: '1px solid #aaa',
                backgroundColor: '#fff',
                ...(justify !== 'left' && { right: 0 }),
                ...(justify === 'left' && { borderTopRightRadius: 4 }),
                ...(justify !== 'left' && { borderTopLeftRadius: 4 }),
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
                zIndex: 1000
            },
            suggestionsList: {
                margin: 0,
                padding: 0,
                listStyleType: 'none',
            },
            suggestion: {
                cursor: 'pointer',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                padding: '5px 10px'
            },
            suggestionHighlighted: {
                backgroundColor: '#ddd'
            }
        };


        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: "Diagnosis Search",
            value,
            onChange: this.onChange,
            onBlur: this.onBlur,
        };

        return (
            <div className={styles.autosuggest_wrapper}>
                <span className={styles.autosuggest_field}>
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        onSuggestionSelected={this.onSuggestionSelected}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={inputProps}
                        theme={theme}
                    />
                </span>
            </div>
        );
    }
}
